import api from "../../utils/ApiConfig";

export const fetchAllPerformance = async (month) => {
  const response = await api.get("/bo/livreurs/performance", { params: { month } });
  return response.data;
};

export const fetchLivreurTimeline = async (id, from, to, groupBy = "week") => {
  const response = await api.get(`/bo/livreur/${id}/performance`, {
    params: { from, to, groupBy },
  });
  return response.data;
};
